import { getOrderTrackingShippingLabels, httpStatuses, trackingPageBlockIds } from '@reveni-io/reveni-ui'

import {
  missingDataTypes,
  notActiveOnTypes,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/constants'
import { buildHiddenBlocks } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/helpers'

import { getCriteriaLimitedBlocks, getDateLimitedBlocks } from '../useBlockVisibility/helpers'

const getRealOrderMissingDataBlocks = realOrder => {
  const realOrderDataChecks = [
    {
      blockId: trackingPageBlockIds.orderItems,
      missingData: missingDataTypes.realOrderItems,
      isDataMissing: realOrder.line_items.length === 0,
    },
    {
      blockId: trackingPageBlockIds.shipments,
      missingData: missingDataTypes.realOrderShipments,
      isDataMissing: realOrder.shipping_labels.length === 0,
    },
  ]

  return realOrderDataChecks.filter(check => check.isDataMissing)
}

const getRealOrderHiddenBlocks = ({ realOrder, layout, getBlockVisibility, criteriaOptions, today, timeZone }) => {
  return buildHiddenBlocks({
    missingDataBlocks: getRealOrderMissingDataBlocks(realOrder),
    dateLimitedBlocks: getDateLimitedBlocks({ layout, getBlockVisibility, date: today, timeZone }),
    notActiveOn: notActiveOnTypes.today,
    criteriaLimitedBlocks: getCriteriaLimitedBlocks({
      layout,
      getBlockVisibility,
      criteriaOptions,
      isCriterionActive: criterionId => realOrder.matching_visibility_criterion_ids.includes(criterionId),
    }),
  })
}

export const getRealOrderPreview = ({
  isRealOrderTab,
  realOrder,
  orderTrackingPreview,
  layout,
  getBlockVisibility,
  criteriaOptions,
  today,
  timeZone,
}) => {
  if (!isRealOrderTab || !realOrder) return null

  const resolvedRealOrder = { ...realOrder, shipping_labels: getOrderTrackingShippingLabels(realOrder) }

  return {
    resolvedOrderTrackingPreview: { ...orderTrackingPreview, ...resolvedRealOrder },
    hiddenBlocks: getRealOrderHiddenBlocks({
      realOrder: resolvedRealOrder,
      layout,
      getBlockVisibility,
      criteriaOptions,
      today,
      timeZone,
    }),
  }
}

export const isOrderNotFoundError = error => error.response?.status === httpStatuses.notFound

export const getDisplayedRealOrder = ({ fetchedOrder, selectedRealOrderId, loadingOrder }) => {
  if (!selectedRealOrderId) return null
  if (loadingOrder) return fetchedOrder

  return fetchedOrder?.id === selectedRealOrderId ? fetchedOrder : null
}
